(() => {
  let revision = 0;
  async function syncCart() {
    const current = ++revision;
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (!response.ok) return;
      const cart = await response.json();
      if (current !== revision) return;
      document.querySelectorAll('[data-pf-cart-count]').forEach(badge => {
        badge.textContent = cart.item_count;
        badge.hidden = cart.item_count === 0;
        badge.closest('a')?.setAttribute('aria-label', `Cart, ${cart.item_count} items`);
      });
    } catch (_) { /* Keep the server-rendered count when the connection drops. */ }
  }
  if (typeof subscribe === 'function') subscribe(PUB_SUB_EVENTS.cartUpdate, syncCart);
  window.addEventListener('pageshow', event => { if (event.persisted) syncCart(); });
  const params = new URLSearchParams(window.location.search);
  const view = params.get('pf_view');
  const categoryView = params.get('view');
  const nav = document.querySelector('.pf-mobile-nav');
  if (nav) {
    const categoryHandles = ['men','women','gym-accessories','shoes'];
    const isCategory = categoryView && categoryHandles.some(handle => categoryView === handle || categoryView.startsWith(handle + '-'));
    if (view === 'offers' || view === 'trending' || isCategory) {
      nav.querySelectorAll('[aria-current]').forEach(link => link.removeAttribute('aria-current'));
      const link = isCategory ? nav.querySelector('[data-pf-nav-categories]') : nav.querySelector(`.pf-nav-${view}`);
      link?.setAttribute('aria-current', 'page');
    }
  }
})();
